export const getFullName = (firstName: string, lastName: string): string => {
  return firstName?.trim() && lastName?.trim()
    ? `${firstName} ${lastName}`
    : 'user';
};
